<template>
  <div>
    <div class="fs-header-gradient"></div>
    <div class="fs-header-left" v-if="!isAppBlocked">
      <fs-button data-e2e="Undo" @click.prevent="onUndo" mobileicon="undo" :disabled="!hasHistory">{{ $t('general.undo')}}</fs-button>
    </div>
    <Zoom class="fs-header-middle" v-if="!isAppBlocked"/>
    <div class="fs-header-right" v-if="!isAppBlocked">
      <fs-button data-e2e="Cancel" mobileicon="cancel" :disabled="isSaveDisabled" @click.prevent="onClose">{{ $t('general.cancel')}}</fs-button>
      <fs-button @click.prevent="onExport" mobileicon="save" :disabled="isSaveDisabled" type="primary" data-e2e="Save">{{ $t('general.save')}}</fs-button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';

import Zoom from './Zoom.vue';
import { Getter, Action } from 'vuex-class';
import { FsCanvas, OutputFormat } from '@filestack/canvas-sdk';

@Component({ components: { Zoom } })
class Header extends Vue {

  @Getter('config')
  private config: any;

  @Inject('canvas')
  private canvas: FsCanvas;

  @Getter('isBlocked')
  private isAppBlocked: boolean;

  @Getter('image/hasHistory')
  private hasHistory: boolean;

  @Getter('image/historyState')
  private historyState: any[];

  @Getter('image/lastState')
  private lastState: any;


  @Getter('closeOnSave')
  private closeOnSave: boolean;

  @Action('image/popLastHistoryState')
  private popHistoryState: () => any;

  private get isSaveDisabled() {
    return this.canvas.transform.isCropMode;
  }

  private onExport() {

    if (this.canvas.transform.isCropMode) {
      this.canvas.mask.destroy();
    }

    this.canvas.export(this.config('output') as OutputFormat).then(() => {
      if (this.closeOnSave) {
        this.$root.$destroy();
      }
    });
  }

  private onUndo() {
    this.popHistoryState().then(() => {
      if (!this.lastState) {
        return;
      }

      this.canvas.restoreState(this.lastState);
    });
  }

  private onClose() {
    this.$root.$emit('destroy');
    this.canvas.close();
    // this.$root.$destroy();
  }
}

export default Header;
</script>
